/* ==== NAKATA HANGER emergency standalone Shopify theme for NH.en (2026-10-22) ====
   Replaces nh.js / _s.js / s_product.js from www.nakatahanger.com.
   No request is made to www.nakatahanger.com. */
var nhShop = {
	// "[GIFT]GFT-05M / Men's Suit Hanger / Chocolate" -> notice / name / category / color
	// (same rule as getShopifyCategoryProducts() on NH.en)
	colorIds: [
		["mars brown", "marsBrown"], ["smoked brown", "smokedBrown"], ["washed brown", "washedBrown"],
		["navy", "navy"], ["almond", "almond"], ["chocolate", "chocolate"], ["wine red", "wineRed"],
		["natural", "natural"], ["oak", "oak"], ["ocean blue", "oceanBlue"], ["brown", "brown"],
		["black", "black"], ["unpainted", "noCoating"], ["bronze", "bronze"], ["translucent", "translucent"],
		["rise blue", "riseBlue"], ["rise red", "riseRed"], ["vermilion", "vermilion"], ["lapis lazuli", "lapisLazuli"],
		["white", "white"], ["red", "red"], ["green", "green"],
	],
	esc: function(s) {
		return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
	},
	getColorId: function(color) {
		var c = (color || "").toLowerCase();
		for (var i = 0; i < this.colorIds.length; i++) {
			if (c == this.colorIds[i][0]) return this.colorIds[i][1];
		}
		return "";
	},
	splitName: function(title) {
		var t = title.trim(), notice = "";
		var m = t.match(/^\[(.*?)\](.*)$/);
		if (m) { notice = m[1].trim(); t = m[2].trim(); }
		var parts = t.split("/").map(function(s) { return s.trim(); });
		var r = { notice: notice, name: parts[0], category: "", color: "" };
		var rest = [];
		for (var i = 1; i < parts.length; i++) {
			if (!r.color && this.getColorId(parts[i])) r.color = parts[i]; else rest.push(parts[i]);
		}
		r.category = rest.join(" / ");
		return r;
	},
	escParts: function(r) {
		return { notice: this.esc(r.notice), name: this.esc(r.name), category: this.esc(r.category), color: this.esc(r.color) };
	},
	formatNames: function() {
		var es = document.querySelectorAll("[nh-name]");
		for (var i = 0; i < es.length; i++) {
			var r = this.escParts(this.splitName(es[i].textContent));
			var html = "";
			if (r.notice) html += '<span class="notice">' + r.notice + "</span>";
			html += '<span class="name">' + r.name + "</span>";
			if (r.category) html += '<span class="category">' + r.category + "</span>";
			if (r.color) html += '<span class="color">' + r.color + "</span>";
			es[i].innerHTML = html;
		}
	},

	// ---- lists: one card per shape, color buttons switch image / name / price / link ----
	buildShapes: function() {
		var lists = document.querySelectorAll("ul.product-list[shape]");
		for (var l = 0; l < lists.length; l++) {
			var ul = lists[l], shapes = [], keyToShape = {};
			var lis = ul.querySelectorAll(":scope > li");
			for (var i = 0; i < lis.length; i++) {
				var li = lis[i];
				var r = this.escParts(this.splitName(li.querySelector("[nh-name]").textContent));
				var img = li.querySelector(".image img"), price = li.querySelector(".price");
				var item = {
					url: li.querySelector("a").getAttribute("href"),
					img: img ? img.getAttribute("src") : "",
					name: r.name, category: r.category, color: r.color, notice: r.notice,
					price: price ? price.innerHTML : "",
					soldOut: !!li.querySelector(".soldout"),
				};
				var key = r.name + "|" + r.category + "|" + r.notice;
				if (!keyToShape[key]) { keyToShape[key] = []; shapes.push(keyToShape[key]); }
				keyToShape[key].push(item);
			}
			var html = "";
			for (var s = 0; s < shapes.length; s++) html += this.getShapeHtml(shapes[s]);
			ul.innerHTML = html;
			ul.setAttribute("built", "");
			var total = document.querySelector("[shape-total]");
			if (total) total.innerHTML = shapes.length + (shapes.length == 1 ? " item" : " items");
		}
		var buttons = document.querySelectorAll(".shape .colors .button");
		for (var b = 0; b < buttons.length; b++) {
			buttons[b].addEventListener("click", this.onClickColor);
			buttons[b].addEventListener("mouseenter", this.onClickColor);
		}
	},
	getShapeHtml: function(items) {
		var firsts = "", texts = "", buttons = "";
		for (var i = 0; i < items.length; i++) {
			var c = items[i], sel = (i == 0) ? "true" : "false";
			firsts += '<div class="first" index="' + i + '" selected="' + sel + '">' +
				(c.img ? '<img src="' + c.img + '" alt="" loading="lazy">' : "") +
				(c.notice ? '<div class="notice">' + c.notice + "</div>" : "") + "</div>";
			texts += '<div class="detail" index="' + i + '" selected="' + sel + '" url="' + c.url + '">' +
				'<div class="name">' + c.name + "</div>" +
				(c.category ? '<div class="category">' + c.category + "</div>" : "") +
				(c.color ? '<div class="color">' + c.color + "</div>" : "") +
				'<div class="price">' + (c.soldOut ? "<span nh-red>SOLD OUT</span>" : c.price) + "</div></div>";
			if (items.length > 1 || c.color) {
				buttons += '<span class="button" index="' + i + '" selected="' + sel + '" nh-bg-color="' + this.getColorId(c.color) + '" title="' + c.color + '"></span>';
			}
		}
		return '<li class="shape"><a href="' + items[0].url + '">' +
			'<div class="images">' + firsts + "</div>" +
			'<div class="colors">' + buttons + "</div>" +
			'<div class="details">' + texts + "</div>" +
			"</a></li>";
	},
	onClickColor: function(e) {
		var index = this.getAttribute("index");
		var shape = this.closest(".shape");
		if (e.type == "click") e.preventDefault();
		var es = shape.querySelectorAll("[index]");
		for (var i = 0; i < es.length; i++) es[i].setAttribute("selected", es[i].getAttribute("index") == index ? "true" : "false");
		shape.querySelector("a").href = shape.querySelector('.detail[index="' + index + '"]').getAttribute("url");
	},

	// ---- product description: "[TITLE-1] ... [TEXT-1] ... [IMAGE-1] file.jpg" ----
	// Images named in the description live on www.nakatahanger.com, so they are skipped while it is stopped.
	renderExplain: function() {
		var src = document.getElementById("explain-source"), dst = document.getElementById("explain");
		if (!src || !dst) return;
		var raw = src.innerHTML;
		if (!/\[[A-Z]+(-\d+)*\]/.test(raw)) { dst.innerHTML = raw; return; }
		var blocks = raw.split(/\[([A-Z]+(?:-\d+)*)\]/), html = "";
		for (var i = 1; i < blocks.length; i += 2) {
			var type = blocks[i];
			var body = blocks[i + 1].replace(/^(\s|<br\s*\/?>|<\/p>|<p>)+/i, "").replace(/(\s|<br\s*\/?>|<p>|<\/p>)+$/i, "").trim();
			if (!body || /^(IMAGE|VIDEO)/.test(type)) continue;
			if (/^TITLE/.test(type)) html += '<h3 class="' + type.toLowerCase().replace(/-\d+$/, "") + '">' + body + "</h3>";
			else html += "<p>" + body + "</p>";
		}
		dst.innerHTML = html;
	},

	// ---- product form: option selects -> variant id / price / availability / image ----
	initProductForm: function() {
		var form = document.getElementById("nh-product-form");
		var json = document.getElementById("nh-variants");
		if (!form || !json) return;
		var variants = JSON.parse(json.textContent);
		var selects = form.querySelectorAll("select[data-option-index]");
		var idSelect = document.getElementById("nh-variant-id");
		var price = form.querySelector("[data-price]"), compare = form.querySelector("[data-compare]");
		var add = form.querySelector("[data-add]");
		var money = function(cents) { return "¥" + Math.round(cents / 100).toLocaleString("en-US"); };
		var update = function() {
			var values = [];
			for (var i = 0; i < selects.length; i++) values.push(selects[i].value);
			var v = null;
			for (var j = 0; j < variants.length; j++) {
				if (variants[j].options.join("|") == values.join("|")) { v = variants[j]; break; }
			}
			if (!v) { add.disabled = true; add.value = "Unavailable"; return; }
			idSelect.value = v.id;
			price.textContent = money(v.price);
			if (v.compare_at_price && v.compare_at_price > v.price) { compare.textContent = money(v.compare_at_price); compare.hidden = false; } else { compare.hidden = true; }
			add.disabled = !v.available;
			add.value = v.available ? "Add to Cart" : "Sold Out";
			if (v.featured_image) nhShop.showImage(v.featured_image.src);
			if (history.replaceState) history.replaceState(null, "", location.pathname + "?variant=" + v.id);
		};
		for (var i = 0; i < selects.length; i++) selects[i].addEventListener("change", update);
	},
	showImage: function(src) {
		var main = document.querySelector("#detail .gallery .main img");
		if (main) main.src = src;
	},
	initGallery: function() {
		var thumbs = document.querySelectorAll("#detail .gallery .thumbs li");
		for (var i = 0; i < thumbs.length; i++) {
			thumbs[i].addEventListener("click", function() {
				for (var j = 0; j < thumbs.length; j++) thumbs[j].removeAttribute("selected");
				this.setAttribute("selected", "");
				nhShop.showImage(this.querySelector("img").src);
			});
		}
		if (thumbs.length) thumbs[0].setAttribute("selected", "");
	},

	// ---- header: drawer (SP) and submenus ----
	initHeader: function() {
		var header = document.getElementById("nh-header");
		if (!header) return;
		header.querySelector(".drawer-toggle").addEventListener("click", function() {
			header.setAttribute("menu-opened", header.getAttribute("menu-opened") == "true" ? "false" : "true");
		});
		var subs = header.querySelectorAll(".has-sub .main-item");
		for (var i = 0; i < subs.length; i++) {
			subs[i].addEventListener("click", function() {
				var li = this.parentNode;
				li.setAttribute("opened", li.getAttribute("opened") == "true" ? "false" : "true");
			});
		}
		var hero = document.getElementById("hero"), notice = document.getElementById("nh-notice");
		if (hero && notice) hero.parentNode.insertBefore(notice, hero.nextSibling);
	},
};
document.addEventListener("DOMContentLoaded", function() {
	nhShop.initHeader();
	nhShop.buildShapes();
	nhShop.formatNames();
	nhShop.renderExplain();
	nhShop.initProductForm();
	nhShop.initGallery();
});
